import { useQuery } from 'react-query';
import { ClientMealsListResponse, model as clientMealsModel } from './meals';

export const clientsQueryKey = (clientId) => `client--${clientId}--meals`;

export const useClientMealsList = (clientId, term, filters) =>
  useQuery<ClientMealsListResponse>([clientsQueryKey(clientId), term, filters], () =>
    clientMealsModel.getList(clientId, term, filters),
  );
